import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';
import { WorkspaceRouteService } from '@core/services/workspace-route.service';

/**
 * `/settings` index: workspace general settings when permitted, otherwise the
 * shared account settings shell (teachers, learners, editors, …).
 */
export const settingsIndexGuard: CanActivateFn = () => {
  const perms = inject(PermissionService);
  const router = inject(Router);
  const wsRoute = inject(WorkspaceRouteService);

  if (perms.can('settings.manage')) return true;
  return router.parseUrl(wsRoute.path('settings', 'account'));
};
